import { $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'
import { CartPage } from './cart'

export class CartRemoveButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    event.preventDefault()
    if (isEnterKey(event)) {
      this.update()
    }
  }

  update(): void {
    const cart: CartPage = $elParent('cart-page, cart-drawer', this)
    const index = this.dataset.index

    if (cart && index) {
      cart.updateItem(+index, 0)
    }
  }
}
